import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const AaluDaloSonaNikaloComingSoon = () => {
  const authState = useSelector((state) => state.authReducer);
  const { isLoggedIn } = authState;
  const [userName] = useState(authState.user.name);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
    navigate("/mindspark");
  };

  return (
    <div className="font-sans text-gray-800 bg-gradient-to-br from-fuchsia-100 to-amber-100 scroll-smooth min-h-screen flex flex-col justify-between">
      {/* Hero Section */}
      <section className="relative flex flex-col items-center justify-center px-4 sm:px-6 py-16 sm:py-24 text-center w-full">
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>

        {/* Content container */}
        <div className="relative z-10 max-w-4xl w-full">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 text-white">
            🔥 We are working on exciting and rewarding "Aalu Dalo Sona Nikalo!"
          </h1>
          <p className="text-lg sm:text-xl font-semibold text-white mb-6">
            Keep Visiting. Will be available soon.
          </p>

          {/* Full-width ad banner */}
          <div className="w-full flex justify-center mb-4">
            <img
              src="/assets/ads/kharchojeeto-ad-full.jpg"
              alt="Full Width Ad"
              className="rounded-lg shadow-md w-full max-w-xl sm:max-w-2xl h-auto object-contain"
            />
          </div>

          {/* Two smaller ads */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-4 w-full">
            <img
              src="/assets/ads/kharchojeeto-ad-left.jpg"
              alt="Left Half Ad"
              className="rounded-lg shadow-md w-full sm:w-1/2 max-w-xs h-auto object-contain"
            />
            <img
              src="/assets/ads/kharchojeeto-ad-right.jpg"
              alt="Right Half Ad"
              className="rounded-lg shadow-md w-full sm:w-1/2 max-w-xs h-auto object-contain"
            />
          </div>

          <div className="w-full flex justify-center text-white">
            <p>Advertise with us.</p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-fuchsia-600 text-white py-6 sm:py-10 px-4 sm:px-6 md:px-20 mt-auto">
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
          <p className="text-sm mb-4 md:mb-0">
            © 2025 Think5Whys Global DeepTech Solutions. All rights reserved.
          </p>
          <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-6 text-sm">
            <Link
              to="/about-us"
              className="hover:text-amber-300 transition text-white"
            >
              About
            </Link>
            <Link
              to="/privacy-policy"
              className="hover:text-amber-300 transition text-white"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms-of-use"
              className="hover:text-amber-300 transition text-white"
            >
              Terms of Use
            </Link>
            <Link
              to="/contact-us"
              className="hover:text-amber-300 transition text-white"
            >
              Contact
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AaluDaloSonaNikaloComingSoon;
